module.exports = __webpack_public_path__ + "static/media/search-active.42cb9d05.svg";